import { render, staticRenderFns } from "./RigImport.vue?vue&type=template&id=96338a70"
import script from "./RigImport.vue?vue&type=script&lang=ts"
export * from "./RigImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports